export function addDataLayerEvent (eventName) {
  window.dataLayer = window.dataLayer || []
  if (typeof eventName === 'string') {
    window.dataLayer.push({ event: eventName })
  } else {
    window.dataLayer.push(eventName)
  }
}
